import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { RiskType } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useLanguage } from "../../../../contexts";

const riskTypeController = new RiskType();

export function RiskTypeForm({ riskType, close, onReload }) {
  const { accessToken } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const formik = useFormik({
    initialValues: {
      code: riskType?.code || "",
      name: riskType?.name || "",
    },
    validationSchema: Yup.object({
      code: Yup.string().required("El código es requerido"),
      name: Yup.string().required("El nombre es requerido"),
    }),
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (riskType) {
          await riskTypeController.updateRiskType(accessToken, riskType._id, values);
          toast.success("Tipo de riesgo actualizado");
        } else {
          await riskTypeController.createRiskType(accessToken, values);
          toast.success("Tipo de riesgo creado");
        }
        onReload();
        close();
      } catch (err) {
        toast.error(err?.msg || "Error al guardar");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit} style={{ padding: "0.5rem" }}>
      <ToastContainer position="top-center" autoClose={800} hideProgressBar />
      <Form.Input
        label={<label>{t("code")} <span style={{ color: "#C0392B" }}>*</span></label>}
        name="code"
        value={formik.values.code}
        onChange={(e) => {
          const v = e.target.value;
          formik.setFieldValue("code", v.length > 0 ? v.charAt(0).toUpperCase() + v.slice(1).toLowerCase() : v);
        }}
        error={formik.errors.code}
        placeholder="Ej: RT01"
      />
      <Form.Input
        label={<label>{t("name")} <span style={{ color: "#C0392B" }}>*</span></label>}
        name="name"
        value={formik.values.name}
        onChange={(e) => {
          const v = e.target.value;
          formik.setFieldValue("name", v.charAt(0).toUpperCase() + v.slice(1));
        }}
        error={formik.errors.name}
        placeholder="Ej: Riesgo Mecánico"
      />
      <div style={{ display: "flex", justifyContent: "center", gap: "14px", marginTop: "2rem" }}>
        <button type="submit" disabled={formik.isSubmitting} style={{ background: "#4A7FA5", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer", opacity: formik.isSubmitting ? 0.55 : 1 }}>
          {formik.isSubmitting ? "…" : (riskType ? t("update") : t("save"))}
        </button>
        <button type="button" onClick={close} style={{ background: "#9BAFC4", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer" }}>{t("cancel")}</button>
      </div>
    </Form>
  );
}
